import { ITheme } from '@fluentui/react';
import { CSSProperties } from 'react';

/** Gets the style for the list root. */
export const getSearchListStyle = (theme: ITheme): Partial<CSSProperties> => ({
  borderRadius: theme?.effects?.roundedCorner6,
  // boxShadow: theme?.effects?.elevation8,
  // border: '1px outset ' + theme?.palette?.whiteTranslucent40,
  // paddingTop: '1em',
  height: '100%',
});
